import { useContext, useEffect } from 'react';
import { useIdleTimer } from 'react-idle-timer';
import './idleTimerField.scss';
import AuthContext from '../../contexts/authContext';
import { Logout } from '../../services/signInService/signInService';
import { apiContext } from '../../contexts/apiContext';
import Bowser from "bowser";

const IdleTimerField = () => {
    // const [state, setState] = useState<string>('Active');
    // const [count, setCount] = useState<number>(0);
    // const [remaining, setRemaining] = useState<number>(0);
    const { setAuthenticated } = useContext(AuthContext);
    const { apiUrl, apiVersion, pwaVersion } = useContext(apiContext);

    const onIdle = () => {
        //setState('Idle');
        sessionStorage.removeItem("SOPOtoken");
        sessionStorage.removeItem("guidSession");
        Logout(apiUrl, apiVersion)?.then((response: any) => {
            setAuthenticated(false);
        }).catch((error: any) => {
            setAuthenticated(false);
        })
    }

    // const onActive = () => {
    //     setState('Active');
    // }

    // const onAction = () => {
    //     setCount(count + 1)
    // }

    /*const { getRemainingTime } = */useIdleTimer({
        onIdle,
        //onActive,
        //onAction,
        timeout: 1000 * 60 * 1440,
        throttle: 500
    })

    useEffect(() => {
        const interval = setInterval(() => {
            //setRemaining(Math.ceil(getRemainingTime() / 1000))
        }, 500)

        return () => {
            clearInterval(interval)
        }
    })

    const version = () => {
        return (<><p className='versionWrapper'>wersja aplikacji {pwaVersion}</p>
            {browserVersion()}</>)
    }

    const browserVersion = () => {
        var result = Bowser.getParser(window.navigator.userAgent);
        return (<><p className='versionWrapper'>{"przeglądarka " + result.getBrowserName().toLowerCase() +
        " wersja " + result.getBrowserVersion().toLowerCase()}</p><p>{"system " + result.getOSName().toLowerCase()}</p></>)
    }

    return (
        <div className='idleTimerWrapper'>
            {version()}
        </div>
    )
}

export default IdleTimerField;